import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpHeaders,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {AuthService} from "./auth.service";
import {ToastService} from "../../@admin/services/message/toast.service";
import {ErrorListWithProperty} from "../../api/models/response/utility-response";
import {environment} from "../../../environments/environment";

/**
 * Intercept
 *
 * @param req
 * @param next
 */

export const authInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService: AuthService = inject(AuthService);
  const _toast: ToastService = inject(ToastService);
  // const appConfigService: AppConfigurationService = inject(AppConfigurationService);
  // Clone the request object
  let headerReq: HttpRequest<any>;

  /* -----------------------------------------------
   Request - Global Http Header Handling for all Api
  --------------------------------------------------  */
  const validKey = req.url.includes('/Cache') ? environment?.apiConfig.valuationValidKey : environment?.apiConfig.validKey
  const defaultHeaders: HttpHeaders = req.headers
    .set('valid-Key', validKey || '')
    .set('Content-Type', 'application/json');
  /* if accessToken exist in localStorage */
  // req.url.includes('/account/') ||
  if (authService.accessToken) {
    headerReq = req.clone({
      headers: defaultHeaders
        .set('Authorization', authService.accessToken ? 'Bearer ' + authService.accessToken : ''),
    });
  } else {
    headerReq = req.clone({headers: defaultHeaders});
  }

  // Response
  return next(headerReq).pipe(
    catchError((error) => {
      // Extract Errors from Blob Type Res
      if (error.error instanceof Blob) {
        extractErrorFromBlob(error.error, error, authService, _toast);
      } else {
        manageErrors(error, _toast, authService);
      }
      return throwError(() => error);
    })
  );
};

export function manageErrors(error: HttpErrorResponse, _toast: ToastService, authService:AuthService): void {
  // Catch "401 Unauthorized" responses
  if (error.status === HttpStatusCode.Unauthorized) {
    _toast.error({
      detail: '',
      summary: 'Unauthorized!'
    });
    authService.clearStorageNavigateSignIn();
  } else if (error.status === HttpStatusCode.NotFound) {
    _toast.error({
      detail: error.message,
      summary: error.name
    });
  } else if (error.status === HttpStatusCode.BadRequest) {
    // Show validation errors from the response
    if (error.error.errors) {
      const errorMessages: any[] = [];
      for (const key in error.error.errors) {
        if (error.error.errors.hasOwnProperty(key)) {
          errorMessages.push(...error.error.errors[key]);
        }
      }
      // Pass the array of error messages to the toast
      _toast.error({summary: 'Validation Errors', detail: errorMessages});
    } else {
      _toast.error({detail: error.error?.message, summary: error.error?.title});
    }
  } else if (error.status === HttpStatusCode.UnprocessableEntity) {
    // Show Error Message in List in Single Toaster
    if (Array.isArray(error.error) && error.error?.length) {
      const errorList: ErrorListWithProperty[] = error.error;
      errorList.forEach((opt: ErrorListWithProperty, index: number): void => {
        opt.id = index + 1;
      });
      // _toast.error(errorList);
    } else {
      _toast.error({detail: error.error?.message, summary: error.error?.title});
    }
  } else if (error.status === HttpStatusCode.InternalServerError) {
    if (error.error) {
      const errorMessages: any[] = [];
      if (error.error['exception'])
        errorMessages.push(error.error['exception'])
      if (error.error['innerException'])
        errorMessages.push(error.error['innerException'])
      _toast.error({summary: error.error['message'], detail: errorMessages});
    } else {
      _toast.error({detail: error.error?.message, summary: error.error?.title});
    }
  } else if (error.status === HttpStatusCode.Forbidden) {
    _toast.error({detail: error.error?.message});
  } else {
    _toast.error({detail: error.error?.message, summary: error.error?.title});
  }
}

export function extractErrorFromBlob(blob: Blob, error: any, authService: AuthService, toastService: ToastService): void {
  const reader: FileReader = new FileReader();
  reader.readAsText(blob);
  reader.onload = (): void => {
    error.error = JSON.parse(reader.result as any);
    manageErrors(error, toastService, authService);
  };
}
